module.exports = __webpack_public_path__ + "img/Frame2362.e2d38663.png";